import React from 'react';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import WhatsAppButton from 'components/ui/WhatsAppButton';
import Icon from 'components/AppIcon';
import { Link } from 'react-router-dom';

const BusinessTherapyServicesPage = () => {
  const therapyModules = [
    {
      icon: 'AlertCircle',
      title: 'Intervention de Crise',
      description: 'Diagnostic rapide et intervention d\'urgence pour stabiliser votre organisation en situation de crise.',
      features: ['Diagnostic express 48h', 'Plan d\'intervention immédiat', 'Stabilisation équipes'],
      timeline: '2-4 semaines',
      successRate: '95%'
    },
    {
      icon: 'Heart',
      title: 'Guérison Organisationnelle',
      description: 'Traitement en profondeur des dysfonctionnements systémiques et reconstruction des fondations saines.',
      features: ['Analyse causes profondes', 'Thérapie processus', 'Reconstruction culturelle'],
      timeline: '3-6 mois',
      successRate: '88%'
    },
    {
      icon: 'Target',
      title: 'Réalignement Stratégique',
      description: 'Redéfinition de la vision, des objectifs et alignment de l\'organisation sur sa nouvelle direction.',
      features: ['Redéfinition vision', 'Alignment stratégique', 'Mobilisation équipes'],
      timeline: '2-4 mois',
      successRate: '92%'
    },
    {
      icon: 'Shield',
      title: 'Renforcement Résilience',
      description: 'Développement des capacités d\'adaptation et de résistance aux chocs futurs.',
      features: ['Capacités adaptation', 'Système alerte précoce', 'Culture résilience'],
      timeline: '4-8 mois',
      successRate: '90%'
    }
  ];

  const processSteps = [
    {
      icon: 'Search',
      title: 'Diagnostic Complet',
      description: 'Analyse approfondie des symptômes organisationnels et identification des causes profondes'
    },
    {
      icon: 'Clipboard',
      title: 'Plan de Traitement',
      description: 'Élaboration d\'une stratégie thérapeutique personnalisée adaptée à votre contexte'
    },
    {
      icon: 'Zap',
      title: 'Intervention Active',
      description: 'Mise en œuvre des solutions curatives avec accompagnement continu de nos experts'
    },
    {
      icon: 'CheckCircle',
      title: 'Suivi & Prévention',
      description: 'Monitoring des progrès et renforcement des immunités organisationnelles'
    }
  ];

  const caseStudies = [
    {
      company: 'TechStart Solutions',
      industry: 'Technologie',
      challenge: 'Crise de liquidité majeure avec risque de faillite',
      result: 'Retour à la rentabilité en 6 mois, croissance +25%',
      testimonial: 'L\'intervention thérapeutique nous a littéralement sauvés. Leur approche holistique a transformé notre crise en opportunité.',
      author: 'Marc Dubois, CEO'
    },
    {
      company: 'Industrie Moderne SA',
      industry: 'Manufacturing',
      challenge: 'Culture toxique avec turnover de 65%',
      result: 'Turnover réduit à 8%, productivité +45%',
      testimonial: 'Nous pensions que notre culture était impossible à changer. L\'équipe a prouvé le contraire avec des résultats spectaculaires.',
      author: 'Claire Martin, DRH'
    },
    {
      company: 'GlobalMerge Corp',
      industry: 'Services Financiers',
      challenge: 'Échec d\'intégration post-fusion',
      result: 'Fusion réussie, synergies à 120% des objectifs',
      testimonial: 'L\'expertise thérapeutique a transformé notre fusion ratée en succès exemplaire.',
      author: 'Philippe Rousseau, DG'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <WhatsAppButton />
      
      {/* Section 1: Hero */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="Heart" size={20} style={{ color: '#9B8E57' }} />
                <span className="text-sm font-semibold" style={{ color: '#9B8E57' }}>
                  Excellence en Business Thérapie
                </span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Business Thérapie Premium
              </h1>
              
              <p className="text-xl md:text-2xl font-semibold" style={{ color: '#9B8E57' }}>
                Résilience & Transformation : Guérissez les blocages pour libérer le potentiel
              </p>
              
              <p className="text-lg text-gray-300 leading-relaxed">
                Un accompagnement ciblé pour surmonter les crises, redéfinir la vision stratégique 
                et aligner la culture d'entreprise sur les objectifs de croissance. Transformez vos 
                difficultés organisationnelles en opportunités de croissance durable.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link 
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                  style={{ 
                    backgroundColor: '#96121D',
                    boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#7d0f18';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#96121D';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Diagnostic Gratuit
                  <Icon name="ArrowRight" size={20} className="ml-2" />
                </Link>
                
                <Link 
                  to="/service-request-form"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg border-2 transition-all duration-300"
                  style={{ 
                    borderColor: '#9B8E57',
                    color: '#9B8E57'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#9B8E57';
                    e.target.style.color = '#ffffff';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#9B8E57';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Nos Protocoles
                  <Icon name="FileText" size={20} className="ml-2" />
                </Link>
              </div>
            </div>

            {/* Right Content - Stats Cards */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="TrendingUp" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">95%</div>
                <div className="text-gray-300 text-sm">Taux de Résolution</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="Award" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">80%</div>
                <div className="text-gray-300 text-sm">Amélioration Performance</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="Users" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">150+</div>
                <div className="text-gray-300 text-sm">Organisations Guéries</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="Heart" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">90%</div>
                <div className="text-gray-300 text-sm">Satisfaction Dirigeants</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Therapy Modules */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Protocoles de Thérapie d'Entreprise
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Nos interventions thérapeutiques spécialisées pour chaque type de difficulté organisationnelle
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {therapyModules?.map((module, index) => (
              <div 
                key={index}
                className="group bg-gray-50 rounded-2xl p-8 transition-all duration-300 hover:shadow-xl border-2 border-transparent"
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = index % 2 === 0 ? '#96121D' : '#9B8E57';
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-start space-x-4">
                    <div 
                      className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110"
                      style={{ 
                        backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                      }}
                    >
                      <Icon 
                        name={module?.icon} 
                        size={32} 
                        style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                      />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {module?.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {module?.description}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-3 mb-6">
                  {module?.features?.map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <Icon 
                        name="CheckCircle" 
                        size={20} 
                        style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }}
                      />
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div className="flex items-center space-x-4">
                    <div className="text-sm">
                      <span className="text-gray-500">Durée:</span>
                      <span className="font-semibold text-gray-900 ml-2">{module?.timeline}</span>
                    </div>
                    <div className="text-sm">
                      <span className="text-gray-500">Succès:</span>
                      <span className="font-semibold" style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }}>
                        {module?.successRate}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3: Therapeutic Process */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Processus Thérapeutique en 4 Étapes
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Notre approche holistique combine diagnostic, traitement et prévention pour une guérison durable
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps?.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                  <div 
                    className="w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-6 shadow-lg"
                    style={{ 
                      backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                    }}
                  >
                    <Icon 
                      name={step?.icon} 
                      size={32} 
                      style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                    />
                  </div>
                  <div className="text-center">
                    <div 
                      className="inline-flex items-center justify-center w-8 h-8 rounded-full text-white font-bold text-sm mb-4"
                      style={{ backgroundColor: index % 2 === 0 ? '#96121D' : '#9B8E57' }}
                    >
                      {index + 1}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{step?.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{step?.description}</p>
                  </div>
                </div>
                {index < processSteps?.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <Icon name="ArrowRight" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 4: Case Studies & CTA */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Case Studies */}
          <div className="mb-20">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Histoires de Transformation Réussies
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Découvrez comment notre approche thérapeutique a permis la guérison complète d'organisations en crise
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {caseStudies?.map((study, index) => (
                <div 
                  key={index}
                  className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300"
                >
                  <div className="mb-6">
                    <div 
                      className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4"
                      style={{ 
                        backgroundColor: 'rgba(155, 142, 87, 0.1)',
                        color: '#9B8E57'
                      }}
                    >
                      {study?.industry}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{study?.company}</h3>
                    <p className="text-gray-600 text-sm mb-4">
                      <span className="font-semibold">Défi:</span> {study?.challenge}
                    </p>
                    <p className="text-gray-900 text-sm font-semibold mb-4">
                      <Icon name="TrendingUp" size={16} className="inline mr-2" style={{ color: '#96121D' }} />
                      {study?.result}
                    </p>
                  </div>

                  <div className="border-t border-gray-200 pt-6">
                    <p className="text-gray-600 text-sm italic mb-4">"{study?.testimonial}"</p>
                    <p className="text-gray-900 text-sm font-semibold">— {study?.author}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div 
            className="rounded-3xl p-12 text-white text-center"
            style={{
              background: 'linear-gradient(135deg, #96121D 0%, #9B8E57 100%)'
            }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Commencez Votre Thérapie d'Entreprise Aujourd'hui
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto opacity-90">
              Ne laissez pas les difficultés compromettre l'avenir de votre organisation. Nos thérapeutes d'entreprise sont prêts à vous accompagner.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold bg-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                style={{ color: '#96121D' }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Consultation Gratuite
                <Icon name="ArrowRight" size={20} className="ml-2" />
              </Link>
              <Link
                to="/service-request-form"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold border-2 border-white text-white rounded-lg transition-all duration-300"
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Demander un Devis
                <Icon name="FileText" size={20} className="ml-2" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BusinessTherapyServicesPage;